import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import pkg from '../../../package.json';
import { COMMON_NAMESPACE } from '@/i18n';
import '@/components/WelcomeFooter/WelcomeFooter.sass';
import logoBlack from '@/assets/brand/logo_black.png';
import logoWhite from '@/assets/brand/logo_white.png';
import { isOnDarkBackground } from '@/helpers/backgroundTone';

export function WelcomeFooter(): JSX.Element {
  const { t } = useTranslation(COMMON_NAMESPACE);
  const versionLabel = `v${pkg.version} ${t('poweredBy')}`;
  const footerRef = useRef<HTMLElement>(null);
  const [onDarkBackground, setOnDarkBackground] = useState(false);

  // Logo preto sobre fundo claro, branco sobre escuro — decidido pelo fundo que
  // aparece atrás do rodapé, antes da primeira pintura.
  useLayoutEffect(() => {
    if (footerRef.current) {
      setOnDarkBackground(isOnDarkBackground(footerRef.current));
    }
  }, []);

  return (
    <Box
      component="footer"
      ref={footerRef}
      className="welcome-footer"
      data-testid="welcome-footer"
    >
      <Typography component="span" className="welcome-footer__version">
        {/* {versionLabel} */}
        {versionLabel}
      </Typography>
      <Typography component="span" className="welcome-footer__brand">
        {/* {t('identiLaAlt')} */}
       <Box
         component="img"
         src={onDarkBackground ? logoWhite : logoBlack}
         alt={t('identiLaAlt')}
         className="welcome-footer__logo"
       />
      </Typography>
    </Box>
  );
}
